<template>
  <div class="plan-card">
    <!-- Header Section (Flex Column) -->
    <div class="plan-header">
      <h3 class="plan-name">{{ plan.name }}</h3>
      <div class="plan-price">{{ plan.price }} kr</div>
      <p class="plan-frequency">Per leieforhold / måned</p>
    </div>

    <!-- Divider Line -->
    <hr class="plan-divider">

    <!-- Bullet Points List -->
    <ul class="plan-features">
      <li v-for="(bullet, index) in bulletPoints" :key="index" class="feature-item" :class="{ active: bullet.active }">
        <i class="budicon-check-ui feature-icon"></i>
        <span class="feature-text">{{ bullet.text }}</span>
      </li>
    </ul>

    <!-- Upgrade Button -->
    <div class="plan-footer">
      <button class="upgrade-button btn btn-primary" @click="$emit('upgrade')">
        Oppgrader
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TenancySubscriptionSinglePlanCard',
  props: {
    plan: {
      type: Object,
      required: true,
      validator: (plan) => plan.name && plan.price !== undefined
        && typeof plan.name === 'string'
        && typeof plan.price === 'number'
    },
    bulletPoints: {
      type: Array,
      default: () => [],
      validator: (points) => points.every(p =>
        typeof p.text === 'string' && typeof p.active === 'boolean'
      )
    },
  },
  emits: ['upgrade']
}
</script>

<style scoped lang="scss">
.plan-card {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  position: relative;
  transition: all 0.2s ease;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    border-color: #3b82f6;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }
}

.plan-header {
  display: flex;
  flex-direction: column;
  text-align: center;
  margin-bottom: 20px;

  .plan-name {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin: 0 0 12px 0;
  }

  .plan-price {
    font-size: 32px;
    font-weight: 800;
    color: #059669;
    margin: 0 0 8px 0;
  }

  .plan-frequency {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
    font-style: italic;
  }
}

.plan-divider {
  border: none;
  height: 1px;
  background-color: #e5e7eb;
  margin: 0 0 24px 0;
}

.plan-features {
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;
  flex-grow: 1;

  .feature-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .feature-icon {
      color: #10b981;
      font-size: 14px;
      margin-top: 2px;
      flex-shrink: 0;
    }

    .feature-text {
      color: #374151;
      font-size: 14px;
      line-height: 1.5;
    }

    &:not(.active) {
      opacity: 0.5;

      .feature-icon {
        color: #d1d5db;
      }

      .feature-text {
        color: #9ca3af;
      }
    }
  }
}

.plan-footer {
  margin-top: auto;

  .upgrade-button {
    width: 100%;
    padding: 12px 24px;
    font-weight: 600;
    border-radius: 8px;
  }
}
</style>